import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux'
import service from "../common/service";
import moment from "moment";
import { getCookie } from "../common/functions";
let User = getCookie("PAFUser");

// Components
// import Newsletter from "../components/Newsletter";

const mapStateToProps = state => ({
  menuEnbleDate:state.menuEnbleDate
});
class Footer extends Component {

constructor(props) {
    super(props);
    this.apiServe = new service();
}

gotoPage(to) {
  let url = ''
  if (to === "schedule") {
    url =  process.env.REACT_APP_HOME_URL + `program/schedule/`
  } else if (to === "new-frontier") {
    url =  process.env.REACT_APP_HOME_URL + `program/new-frontier/`
  } else if (to === "beyond-films") {
    url =  process.env.REACT_APP_HOME_URL + `program/beyond-films/`
  } else if (to === "live-events") {
    url = process.env.REACT_APP_HOME_URL + `program/live-events`
  } else if (to === "partner-events") {
    url = process.env.REACT_APP_HOME_URL + `program/partner-events/`
  } else if(to === 'highlights'){
    url = process.env.REACT_APP_HOME_URL + 'highlight'
  }
  else if(to === 'about'){
    url = process.env.REACT_APP_HOME_URL + 'about'
  }
  else if(to === 'community-agreement'){
    url = process.env.REACT_APP_HOME_URL + 'community-agreement'
  }
  else {
    url =  process.env.REACT_APP_HOME_URL + `program/films/`
  }
  return url
}
  render() {
    const menuEnableDates = localStorage.getItem('MENUE_ENABLE_DATE') ? JSON.parse(localStorage.getItem('MENUE_ENABLE_DATE')) : this.props.menuEnbleDate
    const has1920width = Boolean(document.getElementById("max_container_view"));
    return (
      <footer>
        {/* Newsletter */}
        {/* <Newsletter /> */}

        {/* Footer */}
        <div className="sd_large_footer">
            <div className="sd_footer_links_wpr">
                <div className={`sd_large_container sd_footer_container festival_container ${has1920width ? 'festival_container_1920' : ''}`}>
                <div className="sd_footer_links_content sd_flex sd_desktop_footer">
                    <div className="sd_footer_links">
                        <div>
                        <label className={`sd_flex sd_aligncenter`}>
                        Quick Links
                        </label>
                        <ul className={`sd_links_list`} id="helpFullLink">
                          {moment().isBetween(menuEnableDates['SHOP_MERCH']?.startDate, menuEnableDates['SHOP_MERCH']?.endDate) && moment().isBetween(menuEnableDates['SHOP_MERCH']?.footerStartDate, menuEnableDates['SHOP_MERCH']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HEADER_FESTIVAL_MERCH} target="_blank">Merch </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['HIGHLIGHT']?.startDate, menuEnableDates['HIGHLIGHT']?.endDate) && moment().isBetween(menuEnableDates['HIGHLIGHT']?.footerStartDate, menuEnableDates['HIGHLIGHT']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'highlights/'}> Highlights </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['MAP']?.startDate, menuEnableDates['MAP']?.endDate) && moment().isBetween(menuEnableDates['MAP']?.footerStartDate, menuEnableDates['MAP']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL+"media/maps"}> Map </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['VENUE']?.startDate, menuEnableDates['VENUE']?.endDate) && moment().isBetween(menuEnableDates['VENUE']?.footerStartDate, menuEnableDates['VENUE']?.footerEndDate) && <li><a href={process.env.REACT_APP_HOME_URL+"venues/"}>Venues</a></li>}
                          {moment().isBetween(menuEnableDates['LODGING']?.startDate, menuEnableDates['LODGING']?.endDate) && moment().isBetween(menuEnableDates['LODGING']?.footerStartDate, menuEnableDates['LODGING']?.footerEndDate) && <li><a href={process.env.REACT_APP_LODGING_URL + 'lodging/'}  target="_blank">Lodging</a></li>}
                          <li>
                            <a href={process.env.REACT_APP_HOME_URL+'short-film-tour'}> Short Film Tour </a>
                          </li>
                          {moment().isBetween(menuEnableDates?.['FESTIVAL_2027_BOULDER']?.startDate, menuEnableDates?.['FESTIVAL_2027_BOULDER']?.endDate) && moment().isBetween(menuEnableDates?.['FESTIVAL_2027_BOULDER']?.footerStartDate, menuEnableDates?.['FESTIVAL_2027_BOULDER']?.footerEndDate) && <li><a href={process.env.REACT_APP_SUNDANCE_SITE_URL + 'boulder'}  target="_blank">The Festival’s 2027 Move to Boulder</a></li>}
                        </ul>
                        </div>
                    </div>
                    {moment().isBetween(menuEnableDates['FPG']?.startDate, menuEnableDates['FPG']?.endDate) && moment().isBetween(menuEnableDates['FPG']?.footerStartDate, menuEnableDates['FPG']?.footerEndDate) && <div className="sd_footer_links">
                        <div>
                        <div className="sd_flex sd_aligncenter">
                        <label className={`sd_flex sd_aligncenter`}>
                          Program
                        </label>
                        </div>
                        <ul className={`sd_links_list`} id='programLink'>
                            {moment().isBetween(menuEnableDates['FPG_FILMS']?.startDate, menuEnableDates['FPG_FILMS']?.endDate) && moment().isBetween(menuEnableDates['FPG_FILMS']?.footerStartDate, menuEnableDates['FPG_FILMS']?.footerEndDate) && <li>
                            <a href={this.gotoPage('films')}>Films</a>
                            </li>}
                            {moment().isBetween(menuEnableDates['FPG_BEYOND_FILMS']?.startDate, menuEnableDates['FPG_BEYOND_FILMS']?.endDate) && moment().isBetween(menuEnableDates['FPG_BEYOND_FILMS']?.footerStartDate, menuEnableDates['FPG_BEYOND_FILMS']?.footerEndDate) && <li>
                            <a href={this.gotoPage('beyond-films')} >Beyond Film</a>
                            </li>}
                            {moment().isBetween(menuEnableDates['FPG_PARTNER_EVENTS']?.startDate, menuEnableDates['FPG_PARTNER_EVENTS']?.endDate) && moment().isBetween(menuEnableDates['FPG_PARTNER_EVENTS']?.footerStartDate, menuEnableDates['FPG_PARTNER_EVENTS']?.footerEndDate) && <li>
                              <a href={this.gotoPage('partner-events')} >Partner Events</a>
                            </li>}
                            {moment().isBetween(menuEnableDates['FPG_SCHEDULE']?.startDate, menuEnableDates['FPG_SCHEDULE']?.endDate) && moment().isBetween(menuEnableDates['FPG_SCHEDULE']?.footerStartDate, menuEnableDates['FPG_SCHEDULE']?.footerEndDate) && <li><a href={this.gotoPage('schedule')}>Schedule</a></li>}
                        </ul>
                        </div>
                    </div>}
                    {moment().isBetween(menuEnableDates['TICKETING']?.startDate, menuEnableDates['TICKETING']?.endDate) && moment().isBetween(menuEnableDates['TICKETING']?.footerStartDate, menuEnableDates['TICKETING']?.footerEndDate) && <div className="sd_footer_links">
                        <div>
                        <label className={`sd_flex sd_aligncenter`}>
                        Tickets</label>
                        
                        <ul className={`sd_links_list`} id="ticketLink">
                          {moment().isBetween(menuEnableDates['TICKETING_INPERSON']?.startDate, menuEnableDates['TICKETING_INPERSON']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_INPERSON']?.footerStartDate, menuEnableDates['TICKETING_INPERSON']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'tickets/in-person'}> In Person </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['TICKETING_ONLINE']?.startDate, menuEnableDates['TICKETING_ONLINE']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_ONLINE']?.footerStartDate, menuEnableDates['TICKETING_ONLINE']?.footerEndDate) && <li>
                          <a href={process.env.REACT_APP_HOME_URL + 'tickets/online'}>Online</a>
                          </li>}
                          {moment().isBetween(menuEnableDates['TICKETING_COMPARE']?.startDate, menuEnableDates['TICKETING_COMPARE']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_COMPARE']?.footerStartDate, menuEnableDates['TICKETING_COMPARE']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'tickets/compare-ticket'}> Compare Tickets </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['TICKETING_FAQ']?.startDate, menuEnableDates['TICKETING_FAQ']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_FAQ']?.footerStartDate, menuEnableDates['TICKETING_FAQ']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'tickets/faq'}>FAQ</a>
                          </li>}
                        </ul>
                        </div>
                    </div>}
                    {moment().isBetween(menuEnableDates['HOW_TO_FEST']?.startDate, menuEnableDates['HOW_TO_FEST']?.endDate) && moment().isBetween(menuEnableDates['HOW_TO_FEST']?.footerStartDate, menuEnableDates['HOW_TO_FEST']?.footerEndDate) && <div className="sd_footer_links">
                        <div>
                        <label className={`sd_flex sd_aligncenter`}>
                        How to Fest</label>
                        
                        <ul className={`sd_links_list`} id="howToFestLink">
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/at-a-glance'}>  At a Glance </a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/ticketing'}> Ticketing </a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/attend-in-person'}>Attend in Person</a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/maps'}>Maps</a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/watch-online'}>Watch Online</a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/accessibility'}> Accessibility </a>
                          </li>
                        </ul>
    
                        </div>
                    </div>}
                    <div className="sd_footer_links">
                    <div>
                      <label className={`sd_flex sd_aligncenter`}>
                      Connect
                      </label>
                        <ul className={`sd_links_list`} id="helpFullLink">
                          <li>
                            <a href={process.env.REACT_APP_SUNDANCE_SITE_URL+'support/'} target="_blank"> Support Sundance Institute </a>
                          </li>
                          <li>
                            <a href={process.env.REACT_APP_HOME_URL+'contact'}> Contact Us </a>
                          </li>
                          <li>
                            <a href={process.env.REACT_APP_INDUSTRY_URL} target="_blank"> Sundance Film Festival Industry Office </a>
                          </li>
                          <li>
                            <a href={process.env.REACT_APP_PRESS_URL} target="_blank"> Press Center </a>
                          </li>
                          <li>
                            <a href={process.env.REACT_APP_HOME_URL+'sponsors/'}> Sponsors </a>
                          </li>
                        </ul>
                    </div>
                  </div>
                </div>
                <div className="sd_footer_links_content sd_flex sd_mobile_footer">
                  <div>
                    <div className="sd_footer_links">
                        <div>
                        <label className={`sd_flex sd_aligncenter`}>
                        Quick Links
                        </label>
                        <ul className={`sd_links_list`} id="helpFullLink">
                          {moment().isBetween(menuEnableDates['SHOP_MERCH']?.startDate, menuEnableDates['SHOP_MERCH']?.endDate) && moment().isBetween(menuEnableDates['SHOP_MERCH']?.footerStartDate, menuEnableDates['SHOP_MERCH']?.footerEndDate) && <li>
                            <a href={ process.env.REACT_APP_HEADER_FESTIVAL_MERCH} target="_blank">Merch </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['HIGHLIGHT']?.startDate, menuEnableDates['HIGHLIGHT']?.endDate) && moment().isBetween(menuEnableDates['HIGHLIGHT']?.footerStartDate, menuEnableDates['HIGHLIGHT']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'highlights/'}> Highlights </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['MAP']?.startDate, menuEnableDates['MAP']?.endDate) && moment().isBetween(menuEnableDates['MAP']?.footerStartDate, menuEnableDates['MAP']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL+"media/maps"}> Map </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['VENUE']?.startDate, menuEnableDates['VENUE']?.endDate) && moment().isBetween(menuEnableDates['VENUE']?.footerStartDate, menuEnableDates['VENUE']?.footerEndDate) && <li><a href={process.env.REACT_APP_HOME_URL+"venues/"}>Venues</a></li>}
                          {moment().isBetween(menuEnableDates['LODGING']?.startDate, menuEnableDates['LODGING']?.endDate) && moment().isBetween(menuEnableDates['LODGING']?.footerStartDate, menuEnableDates['LODGING']?.footerEndDate) && <li><a href={process.env.REACT_APP_LODGING_URL + 'lodging/'}  target="_blank">Lodging</a></li>}
                          <li>
                            <a href={process.env.REACT_APP_HOME_URL+'contact'}> Contact Us </a>
                          </li>
                          {moment().isBetween(menuEnableDates?.['FESTIVAL_2027_BOULDER']?.startDate, menuEnableDates?.['FESTIVAL_2027_BOULDER']?.endDate) && moment().isBetween(menuEnableDates?.['FESTIVAL_2027_BOULDER']?.footerStartDate, menuEnableDates?.['FESTIVAL_2027_BOULDER']?.footerEndDate) && <li><a href={process.env.REACT_APP_SUNDANCE_SITE_URL + 'boulder'}  target="_blank">The Festival’s 2027 Move to Boulder</a></li>}
                        </ul>
                        </div>
                    </div>
                    {moment().isBetween(menuEnableDates['TICKETING']?.startDate, menuEnableDates['TICKETING']?.endDate) && moment().isBetween(menuEnableDates['TICKETING']?.footerStartDate, menuEnableDates['TICKETING']?.footerEndDate) && <div className="sd_footer_links">
                        <div>
                        <label className={`sd_flex sd_aligncenter`}>
                        Tickets</label>
                        
                        <ul className={`sd_links_list`} id="ticketLink">
                          {moment().isBetween(menuEnableDates['TICKETING_INPERSON']?.startDate, menuEnableDates['TICKETING_INPERSON']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_INPERSON']?.footerStartDate, menuEnableDates['TICKETING_INPERSON']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'tickets/in-person'}> In Person </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['TICKETING_ONLINE']?.startDate, menuEnableDates['TICKETING_ONLINE']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_ONLINE']?.footerStartDate, menuEnableDates['TICKETING_ONLINE']?.footerEndDate) && <li>
                          <a href={process.env.REACT_APP_HOME_URL + 'tickets/online'}>Online</a>
                          </li>}
                          {moment().isBetween(menuEnableDates['TICKETING_COMPARE']?.startDate, menuEnableDates['TICKETING_COMPARE']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_COMPARE']?.footerStartDate, menuEnableDates['TICKETING_COMPARE']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'tickets/compare-ticket'}> Compare Tickets </a>
                          </li>}
                          {moment().isBetween(menuEnableDates['TICKETING_FAQ']?.startDate, menuEnableDates['TICKETING_FAQ']?.endDate) && moment().isBetween(menuEnableDates['TICKETING_FAQ']?.footerStartDate, menuEnableDates['TICKETING_FAQ']?.footerEndDate) && <li>
                            <a href={process.env.REACT_APP_HOME_URL + 'tickets/faq'}>FAQ</a>
                          </li>}
                        </ul>
                        </div>
                    </div>}
                  </div>
                  <div>
                    {moment().isBetween(menuEnableDates['FPG']?.startDate, menuEnableDates['FPG']?.endDate) && moment().isBetween(menuEnableDates['FPG']?.footerStartDate, menuEnableDates['FPG']?.footerEndDate) && <div className="sd_footer_links">
                        <div>
                        <div className="sd_flex sd_aligncenter">
                        <label className={`sd_flex sd_aligncenter`}>
                          Program
                        </label>
                        </div>
                        <ul className={`sd_links_list`} id='programLink'>
                            {moment().isBetween(menuEnableDates['FPG_FILMS']?.startDate, menuEnableDates['FPG_FILMS']?.endDate) && moment().isBetween(menuEnableDates['FPG_FILMS']?.footerStartDate, menuEnableDates['FPG_FILMS']?.footerEndDate) && <li>
                            <a href={this.gotoPage('films')}>Films</a>
                            </li>}
                            {moment().isBetween(menuEnableDates['FPG_BEYOND_FILMS']?.startDate, menuEnableDates['FPG_BEYOND_FILMS']?.endDate) && moment().isBetween(menuEnableDates['FPG_BEYOND_FILMS']?.footerStartDate, menuEnableDates['FPG_BEYOND_FILMS']?.footerEndDate) && <li>
                            <a href={this.gotoPage('beyond-films')} >Beyond Film</a>
                            </li>}
                            {moment().isBetween(menuEnableDates['FPG_PARTNER_EVENTS']?.startDate, menuEnableDates['FPG_PARTNER_EVENTS']?.endDate) && moment().isBetween(menuEnableDates['FPG_PARTNER_EVENTS']?.footerStartDate, menuEnableDates['FPG_PARTNER_EVENTS']?.footerEndDate) && <li>
                              <a href={this.gotoPage('partner-events')} >Partner Events</a>
                            </li>}
                            {moment().isBetween(menuEnableDates['FPG_SCHEDULE']?.startDate, menuEnableDates['FPG_SCHEDULE']?.endDate) && moment().isBetween(menuEnableDates['FPG_SCHEDULE']?.footerStartDate, menuEnableDates['FPG_SCHEDULE']?.footerEndDate) && <li><a href={this.gotoPage('schedule')}>Schedule</a></li>}
                        </ul>
                        </div>
                    </div>}
                    {moment().isBetween(menuEnableDates['HOW_TO_FEST']?.startDate, menuEnableDates['HOW_TO_FEST']?.endDate) && moment().isBetween(menuEnableDates['HOW_TO_FEST']?.footerStartDate, menuEnableDates['HOW_TO_FEST']?.footerEndDate) && <div className="sd_footer_links">
                        <div>
                        <label className={`sd_flex sd_aligncenter`}>
                        How to Fest</label>
                        
                        <ul className={`sd_links_list`} id="howToFestLink">
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/at-a-glance'}>  At a Glance </a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/ticketing'}> Ticketing </a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/attend-in-person'}>Attend in Person</a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/maps'}>Maps</a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/watch-online'}>Watch Online</a>
                          </li>
                          <li>
                              <a href={process.env.REACT_APP_HOME_URL+'how-to-fest/accessibility'}> Accessibility </a>
                          </li>
                        </ul>
    
                        </div>
                    </div>}
                    <div className="sd_footer_links">
                      <div>
                        <label className={`sd_flex sd_aligncenter`}> Connect </label>
                        <ul className={`sd_links_list`} id="helpFullLink">
                          <li>
                            <a href={process.env.REACT_APP_SUNDANCE_SITE_URL+'support/'} target="_blank"> Support Sundance Institute </a>
                          </li>
                          <li>
                            <a href={ process.env.REACT_APP_HOME_URL+'contact'}> Contact Us </a>
                          </li>
                          <li>
                            <a href={process.env.REACT_APP_INDUSTRY_URL} target="_blank"> Sundance Film Festival Industry Office </a>
                          </li>
                          <li>
                            <a href={process.env.REACT_APP_PRESS_URL} target="_blank"> Press Center </a>
                          </li>
                          <li>
                            <a href={ process.env.REACT_APP_HOME_URL+'sponsors/'}> Sponsors </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
            <div className="sd_footer_links_wpr">
            <div className="">
                <div className="sd_footer_wpr sd_flex sd_aligncenter sd_justbetween">
                    <div className="sd_flex sd_aligncenter sd_flex_1_auto sd_justbetween">
                        <div className="sd_footer_logo">
                            <div className="sd_footer_logos sd_aligncenter">
                            <div className="sd_footer_main_logo">
                            <a href={process.env.REACT_APP_SUNDANCE_SITE_URL}  target="_blank" rel="noopener noreferra">
                                <img src={'/images/footer_logo.svg'} alt="Sundance Institute" title="Sundance Institute" />
                            </a>
                            {/* <Link onClick={this.goto.bind(this, process.env.REACT_APP_HOME_OLD_URL)} rel="noopener noreferrer" className="footer_webby_logo">
                                <img src='/images/footer_webby_honoree.png' alt="Sundance Institute" title="Sundance Institute" />
                            </Link> */}
                            </div>
                        </div>
                            <p className="sd_textuppercase">
                            {" "}
                            Copyright &copy; {new Date().getFullYear()} Sundance Institute,
                            All Rights Reserved{" "}
                        </p>
                        </div>
                        <div className="sd_footer_navbar">  
                            <ul>
                                <li>
                                    {/* <a href="https://digital.sundance.org/#about" rel="noreferrer" target="_blank"> About Sundance Institute </a> */}
                                    <a href="https://www.sundance.org/about/us" target="_blank" > About Sundance Institute </a>
                                    {/* <Link onClick={(e)=>this.gotoPage(e,"about")} > About Sundance Institute </Link> */}
                                </li>
                                {/* <li>
                                <a href="https://digital.sundance.org/#help" rel="noreferrer" target="_blank"> Help </a>
                                    <Link onClick={(e)=>this.gotoPage(e,"help")}> Help </Link>
                                </li> */}
                                <li>
                                  <a href={this.gotoPage("community-agreement")} > Community Agreement </a>
                                </li>
                            </ul>
                        </div>
                    </div>  
                    <div className="sd_footer_navigation_bar">
                    <div className="sd_footer_nav">
                    <ul className="sd_flex sd_aligncenter">
                        <li>
                        <a
                            href="https://collab.sundance.org/"
                            target="_blank"
                            rel="noreferrer" className="sd_collab_logo"
                        >
                            <img
                              src={this.apiServe.imageUrl+'assest/'+process.env.REACT_APP_ENVIRONMENT+'/collab_logo.svg'}
                            alt="Sundance Collab"
                            title="Sundance Collab"
                            />
                        </a>
                        </li>
                        <li>
                          <ul className="sd_flex sd_aligncenter">
                            <li>
                              <a href="https://www.instagram.com/sundanceorg/" target="_blank" rel="noopener noreferrer" title="Instagram">
                                <i class="fab fa-instagram"></i>
                              </a>
                            </li>
                            <li className="sff_tiktok_icon">
                              <a href="https://www.tiktok.com/@sundanceorg/" target="_blank" rel="noopener noreferrer" title="TikTok">
                                <i class="fab fa-tiktok"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://www.youtube.com/c/sundancefilmfestival" target="_blank" rel="noopener noreferrer" title="YouTube">
                                <i class="fab fa-youtube"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://www.facebook.com/sundance" target="_blank" rel="noopener noreferrer" title="Facebook">
                                  <i class="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://twitter.com/sundancefest" target="_blank" rel="noopener noreferrer" title="X">
                                <i class="fab fa-x-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://bsky.app/profile/sundance.org" target="_blank" rel="noopener noreferrer" title="Bluesky">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="21" height="21">
                                  <path d="M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z"/>
                                </svg>
                              </a>
                            </li>
                          </ul>
                        </li>
                    </ul>
                    <ul className="sd_flex sd_aligncenter">
                        <li>
                        <a
                            href="https://www.sundance.org/about/privacy-policy"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Privacy Policy
                        </a>
                        </li>
                        <li>
                        <a
                            href="https://www.sundance.org/about/privacy-policy"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Terms &amp; Conditions 
                        </a>
                        </li>
                    </ul>
                    </div>
                </div>
                    <div className="sd_footer_copyright sd_hidden">
                    <p className="sd_textuppercase">
                        {" "}
                        Copyright &copy; {new Date().getFullYear()} Sundance Institute,
                        All Rights Reserved
                    </p>
                    </div>
                </div>
            </div>
            </div>
        </div>
      </footer>
    );
  }
}
export default connect(mapStateToProps, null)(withRouter(Footer)) ;